/**
 * @typedef {Object} Account
 * @property {string=} ID
 * @property {string=} Username
 * @property {string=} Password
 */

/**
 * @typedef {Object} AccountService
 * @property {function(): angular.IPromise<Account[]>} get
 * @property {function(string): angular.IPromise<Account>} delete
 * @property {function(Account): angular.IPromise<Account>} post
 * @property {function(string, Account): angular.IPromise<Account>} patch
 */

const mod = require('../bahabot.module.js')

/**
 * @param {angular.resource.IResourceService} $resource
 * @param {angular.IQService} $q
 * @returns {AccountService}
 */
function bahabotAccountFactory($resource, $q) {
    const Accounts = $resource('/api/protected/accounts', {}, {
        get:    { method: 'GET' },
    });

    const Account = $resource('/api/protected/accounts/:id', {}, {
        get:    { method: 'GET' },
        patch:  { method: 'PATCH' },
        post:   { method: 'POST' }
    });

    return {
        get: function() {
            return Accounts.get().$promise.then(res => res.data);
        },
        delete: function(id) {
            return Account.delete({ id }).$promise.then(res => res.data)
        },
        patch: function(id, account) {
            return Account.patch({ id }, account).$promise.then(res => res.data)
        },
        post: function(account) {
            return Account.post(account).$promise.then(res => res.data)
        }
    };
}

mod.factory('AccountService', ["$resource", bahabotAccountFactory]);
